<template>
  <div class="w-100">
    <h1>Sale report</h1>

    <div class="row mt-4">
<!--      <div class="col-lg-3">-->
<!--        <label for="type">Filter by :</label>-->
<!--        <select v-model="inputFilters.saleBy" id="type" class="form-control">-->
<!--          <option selected value="supplier">supplier</option>-->
<!--          <option value="agent">agent</option>-->
<!--        </select>-->
<!--      </div>-->
      <div class="col-lg-3">
        <label for="date-datepicker">Filter by date:</label>
        <date-picker
            v-model="inputFilters.date"
            id="date-datepicker"
            locale="en"
            format="YYYY-MM-DD"
            range
            clearable
            color="#f42f4b"
        />
      </div>
      <div class="col-lg-2">
        <label class="d-block" style="visibility: hidden">Filter</label>
        <button class="btn btn-primary" @click="filter">
          <i class="fas fa-search"></i>
        </button>
      </div>

      <div class="col-lg-3">
        <label for="type">Sort by :</label>
        <select @change="sortData" v-model="inputFilters.sortBy" id="type" class="form-control">
          <option selected value="total_sales">Total sales</option>
          <option value="total_amount">Total amount</option>
        </select>
      </div>
    </div>


    <div class="table-responsive">
      By default without date filter, statistic generated with start of month until now
      <table class="table mt-2">
        <thead class="thead-light">
        <tr>
          <th scope="col">{{inputFilters.saleBy}}</th>
          <th scope="col">Sales count</th>
          <th scope="col">Total amount</th>
          <th scope="col">Show chart</th>
        </tr>
        </thead>
        <tbody>
        <!--          <router-link tag="tr" :to="{ name: 'cart.show', params: {id: cart.id}}" v-for="cart in items" v-bind:key="cart.id" style="cursor:pointer;">-->
        <tr v-if="sales.length === 0">
          <td style="color: darkred" colspan="2">Data not available, change your date filter</td>
        </tr>
        <tr v-else v-for="sale in sales">
          <td>{{ sale.supplier }}</td>
          <td>{{ sale.total_sales }}</td>
          <td>{{ moneyFormat(sale.total_amount) }}</td>
          <td><button @click="showCompare(sale.supplier)" type="button" class="btn"><i class="fa fa-chart-bar"></i></button></td>
        </tr>

        <!--          </router-link>-->
        </tbody>
      </table>
    </div>
    <modal name="chart-modal" height="auto">
      <div v-if="chartLoaded" class="p-4">
        <div id="chart">
          <apexchart type="area" height="350" :options="chartOptions" :series="series"></apexchart>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import {config, moneyFormat} from "@/helpers";
import multiselect from "vue-multiselect";

export default {
  components: {multiselect},
  data() {
    return {
      myData : {},
      url         : "",
      sort: {
        total_sales: true,
        total_amount : false
      },
      inputFilters: {
        saleBy   : "supplier",
        date: [],
        sortBy: 'total_sales'
      },
      isFiltered  : false,
      filters     : {},
      suppliers: [],
      sales: [],
      chartLoaded: false,
      series: [{
        name: "Daily sale",
        data: []
      }],
      chartOptions: {
        chart: {
          type: 'line',
          height: 350,
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
        },

        title: {
          text: '',
          align: 'left'
        },
        subtitle: {
          text: '',
          align: 'left'
        },
        labels: [],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100]
          }
        },
        xaxis: {
          type: "date",
          categories: []
        },
        yaxis: {
          opposite: true
        },
        legend: {
          horizontalAlign: 'left'
        }
      },
    };
  },
  mounted() {
    this.url = config("BACKEND_ROOT") + "/admin/statistic";
    // this.getSuppliersList();
    this.getSaleStatistic();
  },
  methods: {
    moneyFormat,
    async getSuppliersList() {
      await axios.get(this.url + "/suppliers").then((response) => {
        this.suppliers = response.data.data.suppliers;
      });
    },
    getSaleStatistic(){

      axios.get(this.url+"/report", { params: this.myData }).then((response) => {
        this.sales = response.data.data.sales;
      });
    },
    filter(){
      this.generateFilter();

      this.getSaleStatistic();
    },
    generateFilter(){
      this.isFiltered = true;
      let filters = {};

      if (this.inputFilters.date[0]) {
        filters.date = {};
        filters.date.start = this.inputFilters.date[0];
        filters.date.end = this.inputFilters.date[1];
      }

      if (this.inputFilters.supplier) {
        filters.supplier = this.inputFilters.supplier;
      }

      filters.sortBy = this.inputFilters.sortBy;


      this.filters = filters;

      if (this.isFiltered) {
        let filters = this.filters;
        this.myData = {...this.myData,...filters };

      }
    },
    async showCompare(supplier) {
      this.inputFilters.supplier = supplier;
      this.chartOptions.title.text = supplier + " chart"
      this.generateFilter();

      await axios.get(this.url + "/report/detail", {params: this.myData}).then((response) => {

        this.chartOptions.xaxis.categories = response.data.data.dates;
        this.series[0].data = response.data.data.sale;
        this.chartLoaded = true;
      });

      this.$modal.show("chart-modal");
    },
    sortData(){
      this.filter();
    },
  }
}
</script>

<style scoped>

</style>